define('Jeske.RequiredCheckoutFields.RequiredFieldsModule', [
    'jQuery'
], function (
    jQuery
) {
    'use strict';

    var CONTINUE_SELECTOR = '.order-wizard-step-button-continue, .order-wizard-submitbutton-module-button';
    var NS = '.required-field';
    var POLL_INTERVAL = 2000;
    var RETRY_INTERVAL = 2000;

    // Each entry maps a checkbox on the customer record to the checkout field it
    // makes required. To require another field, add an entry here.
    var FIELD_CONFIGS = [
        {
            key: 'purchaseOrderNumber',
            customFieldId: 'custentity_po_man',
            inputSelector: '#purchase-order-number',
            optionalLabelSelector: '.order-wizard-paymentmethod-purchasenumber-module-purchase-order-optional',
            messageId: 'po-required-message',
            message: 'Purchase Order Number is required for your account.'
        },
        {
            key: 'jobName',
            customFieldId: 'custentity_job_name_required',
            inputSelector: '#custom_field_custbody_job_name',
            optionalLabelSelector: null,
            messageId: 'job-name-required-message',
            message: 'Job Name is required for your account.'
        }
    ];

    // NetSuite returns checkbox custom fields either as booleans or as 'T'/'F'
    // strings depending on how the field is exposed, so 'F' must not read truthy.
    function isChecked(value) {
        if (typeof value === 'string') {
            var normalized = value.trim().toLowerCase();
            return normalized === 't' || normalized === 'true' || normalized === 'yes';
        }
        return !!value;
    }

    function isFilled($input) {
        // String() guards against a non-text control returning an array from val().
        return !!String($input.val() || '').trim();
    }

    var RequiredFieldsModule = {
        observer: null,
        pollId: null,
        retryId: null,
        requiredFields: [],

        mountToApp: function (container) {
            this.container = container;
            this.initializeModule();
        },

        // The profile is bootstrapped into the page when it renders. Reaching
        // checkout as a guest and logging in from within it does not re-bootstrap
        // that context, so the profile can keep reporting the signed-out snapshot
        // until a full page reload. Retry rather than read it once.
        scheduleRetry: function (delay) {
            var self = this;

            if (this.retryId) {
                return;
            }

            this.retryId = setTimeout(function () {
                self.retryId = null;
                self.initializeModule();
            }, delay || RETRY_INTERVAL);
        },

        initializeModule: function () {
            var self = this;
            var userProfile = this.container.getComponent('UserProfile');

            if (!userProfile) {
                this.scheduleRetry(1000);
                return;
            }

            userProfile.getUserProfile().then(function (profile) {
                // A signed-out profile reports every custom field as false. Treating
                // that as "nothing is required" would silently drop the requirement
                // for the rest of the page's life, and it fails open: the order would
                // submit with the fields blank. Keep waiting for a real profile.
                if (!profile || !isChecked(profile.isloggedin)) {
                    self.scheduleRetry();
                    return;
                }

                var customFields = profile.customfields || [];

                self.requiredFields = FIELD_CONFIGS.filter(function (config) {
                    var field = customFields.find(function (candidate) {
                        return candidate.id === config.customFieldId;
                    });
                    return field ? isChecked(field.value) : false;
                });

                if (self.requiredFields.length) {
                    self.startDOMMonitoring();
                }
            }).catch(function () {
                self.scheduleRetry();
            });
        },

        startDOMMonitoring: function () {
            var self = this;

            this.stopDOMMonitoring();

            // Checkout re-renders each wizard step, so watch for the fields appearing.
            this.observer = new MutationObserver(function (mutations) {
                var shouldCheck = mutations.some(function (mutation) {
                    return mutation.type === 'childList' && mutation.addedNodes.length > 0;
                });

                if (shouldCheck) {
                    self.checkAndApplyRequirements();
                }
            });

            this.observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            this.checkAndApplyRequirements();

            // Backup for re-renders that do not surface as childList mutations.
            this.pollId = setInterval(function () {
                self.checkAndApplyRequirements();
            }, POLL_INTERVAL);
        },

        stopDOMMonitoring: function () {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }

            if (this.pollId) {
                clearInterval(this.pollId);
                this.pollId = null;
            }
        },

        checkAndApplyRequirements: function () {
            var self = this;
            var $continue = jQuery(CONTINUE_SELECTOR);

            if (!$continue.length) {
                return;
            }

            var stepId = this.getCurrentStepIdentifier();
            var applied = false;

            this.requiredFields.forEach(function (config) {
                var $input = jQuery(config.inputSelector);

                if (!$input.length) {
                    return;
                }

                // jQuery data lives on the element, so a re-rendered input rebinds itself.
                if ($input.data('required-field-applied') === stepId) {
                    return;
                }

                self.applyFieldRequirement(config, $input, stepId);
                applied = true;
            });

            if (!$continue.data('required-field-bound')) {
                $continue
                    .data('required-field-bound', true)
                    .off('click' + NS)
                    .on('click' + NS, function (e) {
                        var $empty = self.getFirstEmptyInput();

                        if ($empty) {
                            e.preventDefault();
                            e.stopPropagation();
                            self.updateContinueButton();
                            $empty.focus();
                            return false;
                        }
                    });
                applied = true;
            }

            if (applied) {
                this.updateContinueButton();
            }
        },

        getCurrentStepIdentifier: function () {
            var step = jQuery('.order-wizard-step.active').attr('data-step') || 'unknown';
            return window.location.href + '-' + step;
        },

        applyFieldRequirement: function (config, $input, stepId) {
            var self = this;

            $input.data('required-field-applied', stepId);

            // Not every field renders an "(Optional)" marker to hide.
            if (config.optionalLabelSelector) {
                jQuery(config.optionalLabelSelector).hide();
            }

            if (!jQuery('#' + config.messageId).length) {
                $input.after(
                    jQuery('<div>')
                        .attr('id', config.messageId)
                        .css({ color: 'red', margin: '10px 0' })
                        .text(config.message)
                        .hide()
                );
            }

            $input
                .off('input' + NS + ' keyup' + NS + ' change' + NS)
                .on('input' + NS + ' keyup' + NS + ' change' + NS, function () {
                    self.updateContinueButton();
                });
        },

        // Returns the first required input on this step that is still empty, or null.
        getFirstEmptyInput: function () {
            var empty = null;

            this.requiredFields.forEach(function (config) {
                var $input = jQuery(config.inputSelector);

                if (empty || !$input.length || isFilled($input)) {
                    return;
                }

                empty = $input;
            });

            return empty;
        },

        // The continue button is shared by every required field, so its state is
        // computed from all of them at once rather than by each field in turn.
        updateContinueButton: function () {
            var allFilled = true;

            this.requiredFields.forEach(function (config) {
                var $input = jQuery(config.inputSelector);

                // A field that is not rendered on this step is not required here.
                if (!$input.length) {
                    return;
                }

                var filled = isFilled($input);
                jQuery('#' + config.messageId).toggle(!filled);

                if (!filled) {
                    allFilled = false;
                }
            });

            jQuery(CONTINUE_SELECTOR).toggle(allFilled);
        },

        destroy: function () {
            this.stopDOMMonitoring();

            if (this.retryId) {
                clearTimeout(this.retryId);
                this.retryId = null;
            }

            jQuery(CONTINUE_SELECTOR)
                .removeData('required-field-bound')
                .off(NS)
                .show();

            FIELD_CONFIGS.forEach(function (config) {
                jQuery(config.inputSelector).removeData('required-field-applied').off(NS);
                jQuery('#' + config.messageId).remove();
            });
        }
    };

    return RequiredFieldsModule;
});
